import ManageGroupsCtrl from '../groups/ManageGroupsCtrl.js';
import { groupTexts } from '../constants';
import tagsTableUrl from '../tags/tags-table.html';

import indexUrl from './index.html';

class ManageTagsCtrl extends ManageGroupsCtrl {
  tagsTableUrl = tagsTableUrl;

  constructor(
    TagsService,
    PersonaCollection,
    ConfirmService,
    Restangular,
    RestUtils,
    Authentication,
    AccountService,
    SubscriptionUtils,
    AlertService,
    $state,
    $parse,
    $uibModal,
    filterFilter,
    uppercaseFirstFilter
  ) {
    'ngInject';

    super(
      PersonaCollection,
      ConfirmService,
      Restangular,
      RestUtils,
      Authentication,
      AlertService,
      $state,
      $parse,
      $uibModal,
      filterFilter,
      uppercaseFirstFilter
    );

    Object.assign(this, { TagsService, AccountService, SubscriptionUtils });

    this.groupType = 'tag';
  }

  get items() {
    return this.TagsService.tags;
  }

  async deleteItem(tag) {
    await this.ConfirmService.ask({
      question: groupTexts[this.groupType].singleDeletion.title,
      conditions: groupTexts[this.groupType].singleDeletion.conditions,
      title: `Delete ${this.groupType}`,
      warning: 'Warning: this cannot be undone.',
      confirm: 'Delete',
    });

    await this.TagsService.deleteTag(tag);
    this._addSingleDeleteNotification();
  }

  async deleteSelectedTags() {
    await this.ConfirmService.ask({
      question: groupTexts.tag.multipleDeletion.title,
      conditions: groupTexts.tag.multipleDeletion.conditions,
      title: `Delete ${this.groupType}s`,
      confirm: 'Delete',
      warning: 'Warning: this cannot be undone.',
    });

    await this.TagsService.deleteTagsBulk(this.selectedItemIds);

    this._successDelete(this.selectedItemIds);
    this.selectedItemIds = Object.create(null);
  }

  dismissShiftTagsHelp() {
    this.Authentication.user.settings.clientFlags.tagsListTipDismissed = true;
    this.Authentication.syncSettings();
  }
}

export default {
  controller: ManageTagsCtrl,
  controllerAs: 'ctrl',
  templateUrl: indexUrl,
  bindings: {
    disableBulkActions: '<?',
    hideHeader: '<?',
    columnSubset: '<?',
    search: '=?',
  },
};
